export default {"src":"/_next/static/media/Logo_Region_Normandie.15cb4e37.svg","height":670,"width":800,"blurWidth":0,"blurHeight":0};